import React from "react";
import { Button } from "@/components/ui/button";
import { Printer, MicrosoftExcelLogo } from "@phosphor-icons/react";
import { downloadCSV, printReport } from "@/lib/reportExport";

/**
 * Compact export bar for list pages. Renders 2 buttons: Excel · Print.
 * The Print button triggers the browser print dialog on the element whose id
 * is `printRootId` (default: 'report-print-root').
 * `columns` are [{key, label, get?(row)}], `rows` are the data rows.
 */
export default function PageExportBar({
  title,
  filename,
  columns,
  rows,
  printRootId = "report-print-root",
  testidPrefix = "page",
}) {
  const onExcel = () => downloadCSV(filename, columns, rows || []);
  const onPrint = () => printReport(printRootId);
  return (
    <div className="no-print flex items-center gap-2">
      <Button
        variant="outline" size="sm" className="h-9"
        onClick={onExcel}
        data-testid={`${testidPrefix}-excel-btn`}
      >
        <MicrosoftExcelLogo size={14} className="mr-1.5" /> Excel
      </Button>
      <Button
        variant="outline" size="sm" className="h-9"
        onClick={onPrint}
        data-testid={`${testidPrefix}-print-btn`}
      >
        <Printer size={14} className="mr-1.5" /> Print
      </Button>
    </div>
  );
}
